/**
 * Porte de `setTopbar` (`app/web/js/api.js`): mostra só a primeira "parte"
 * do nome do evento na topbar (antes de " e "/"–"/"—"), igual ao legado —
 * o nome completo continua disponível (usar como `title`/tooltip).
 */
export function shortenEventName(name: string): string {
  const [first] = name.split(/\s+[eE]\s+|\s*[—–-]\s*/);
  return first?.trim() || name;
}
